import React from "react";

import styles from "./banner.module.scss";

const AuroraSummitBanner = () => {
	return (
		<div className={`${styles.bannerContent} summitBackground`}>
			<section className={styles.bannerSection}>
				<h1 className={styles.mainTitle}>
					Aurora <span className="text-primary">Partnership</span>
				</h1>
				<h2 className={styles.mainTitle}>Summit 2024</h2>
			</section>
			<section className={styles.bannerSection}>
				<h3 className={styles.secondaryTitle}>September 15-16</h3>
				<h3 className={styles.secondaryTitle}>
					The Red Rock Casino Resort & Spa
				</h3>
				<h3 className={styles.secondaryTitle}>Las Vegas, Nevada</h3>
			</section>
			<section className={styles.bannerSection}>
				<h3 className={styles.thirdTitle}>
					Registration opens at 3:30 PM on the 15th of September
				</h3>
			</section>
			<div className="btn-holder">
				<a
					href="https://risewithaurora.com/partnership-summit-2024/agenda/"
					target="-blank"
					className={styles.bannerBtn}
					title="Aurora Partnership Summit 2024"
				>
					More Details
				</a>
			</div>
		</div>
	);
};

export default AuroraSummitBanner;
